export function getModalTitle(isOpen) {
    return `确定${isOpen ? '开启' : '关闭'}Sidecar自动注入吗？`;
}
export function getModalContent(isOpen) {
    return `${isOpen ? '开启' : '关闭'}自动注入后，会为命名空间配置标签 <istio-injection:enabled>，
                开启自动注入后的命名空间，除Pod的Annotation为 <sidecar.istio.io/inject=“false”> 的工作负载均会注入Sidecar。
                运行中的工作负载，重启后执行自动注入策略。`;
}
